/**
 * Tipos y constantes del dominio "teléfono por países".
 * Responsabilidad única: definir la estructura de datos y constantes compartidas.
 */

export interface CountryPhone {
    iso2: string;
    dialCode: string;
    name: string;
    flag: string;
  }
  
  /**
   * URL del JSON con la lista de países y códigos de marcación.
   * Punto único de configuración para la carga de datos.
   */
  export const COUNTRIES_PHONES_JSON_URL = 'assets/data/countries-phones.json';
  
  /**
   * Códigos de marcación compartidos por varios países: país por defecto cuando
   * AsYouType.getCountry() no devuelve uno (p. ej. +1 puede ser US o CA).
   */
  export const DIAL_CODE_DEFAULT_COUNTRY: Record<string, string> = {
    '1': 'US',
  };